import React, { ComponentProps } from 'react';
import classNames from 'classnames';
import styles from './mfa-selector.module.scss';
import { SecondaryButton } from '@workday/canvas-kit-react/button';
import itemChecked from '../../assets/item-checked.svg';

export type MfaSelectorProps = React.HTMLAttributes<HTMLUListElement>;

const MfaSelectorBase: React.FC<MfaSelectorProps> = ({ className, children, ...props }) => {
    return (
        <ul className={classNames(styles.list, className)} {...props}>
            {children}
        </ul>
    );
};

export interface MfaSelectorItemProps extends React.LiHTMLAttributes<HTMLLIElement> {
    id: string;
    heading: React.ReactNode;
    description: React.ReactNode;
    configureButtonText: string;
    configured?: boolean;
    disabled?: boolean;
    onConfigure?: () => void;
    configureButtonProps?: ComponentProps<typeof SecondaryButton>;
    testIdPrefix?: string;
}

const Item: React.FC<MfaSelectorItemProps> = ({
    id,
    heading,
    description,
    configureButtonText,
    configured = false,
    disabled = false,
    onConfigure,
    configureButtonProps,
    testIdPrefix,
    className,
    ...liProps
}) => {
    const idTitle = `${id}-MfaSelectorItem-title`;
    const idDesc = `${id}-MfaSelectorItem-desc`;

    return (
        <li
            className={classNames(styles.item, className)}
            id={id}
            data-state={configured ? 'configured' : 'unconfigured'}
            data-testid={testIdPrefix ? `${testIdPrefix}-${id}` : undefined}
            {...liProps}>
            <div className={styles.itemTitle} id={idTitle}>
                {heading}
            </div>
            <p className={styles.detail} id={idDesc}>
                {description}
            </p>
            <div className={styles.itemButton}>
                {configured ? (
                    <img src={itemChecked} alt='' aria-hidden='true' className={styles.checkIcon} />
                ) : (
                    <SecondaryButton
                        type='button'
                        size={'small'}
                        disabled={disabled}
                        onClick={onConfigure}
                        aria-describedby={`${idTitle} ${idDesc}`}
                        {...configureButtonProps}>
                        {configureButtonText}
                    </SecondaryButton>
                )}
            </div>
        </li>
    );
};

export const MfaSelector = Object.assign(MfaSelectorBase, { Item }) as typeof MfaSelectorBase & {
    Item: typeof Item;
};
